<template>
  <div
    ref="wrapper"
    class="fixed inset-0 flex items-center justify-center duration-500 opacity-100 z-max bg-concrete min-w-screen"
    :style="{minHeight: $helpers.isPwaOpened() ? '100vh' : 'calc(var(--1svh) * 100)'}"
  >
    <div ref="loader" class="flex flex-col items-center justify-between duration-500 translate-y-5 opacity-0 gap-7 -mt-25">
      <div class="max-w-[128px] max-h-[128px]">
        <img class="w-[128px] h-[128px] rounded-lg" v-if="appLogo" :src="appLogo" />
      </div>
    </div>
    <div
      ref="poweredBy"
      v-if="appBranding == 1"
      class="absolute duration-500 translate-y-5 opacity-0"
      style="bottom: calc(env(safe-area-inset-bottom) + 50px)"
    >
      <t-powered-by />
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import pageUtils from '@/utils/mixins/pageUtils'
  export default {
    name: 't-loader-fullscreen',
    computed: {
      ...mapGetters(['appLogo', 'appBranding'])
    },
    data() {
      return {
        active: true
      }
    },
    mixins: [pageUtils],
    mounted() {
      setTimeout(async () => {
        await this.__refLoaded('loader')
        this.$refs.loader.classList.replace(['opacity-0', 'translate-y-5'], ['opacity-100', 'translate-y-0'])
        if (this.appBranding == 1)
          this.$refs.poweredBy.classList.replace(['opacity-0', 'translate-y-5'], ['opacity-100', 'translate-y-0'])
      }, 500)
    },
    methods: {
      toggleActive() {
        this.active = !this.active
      }
    },
    watch: {
      active(newVal) {
        if (newVal) {
          this.$refs.wrapper.classList.replace(
            ['opacity-0', 'translate-y-5', 'pointer-events-none'],
            ['opacity-100', 'translate-y-0', 'pointer-events-all']
          )
          setTimeout(() => {
            this.$refs.loader.classList.replace(['opacity-0', 'translate-y-5'], ['opacity-100', 'translate-y-0'])
            if (this.appBranding == 1)
              this.$refs.poweredBy.classList.replace(['opacity-0', 'translate-y-5'], ['opacity-100', 'translate-y-0'])
          }, 200)
        } else {
          setTimeout(() => {
            this.$refs.loader.classList.replace(['opacity-100', 'translate-y-0'], ['opacity-0', 'translate-y-5'])
            if (this.appBranding == 1)
              this.$refs.poweredBy.classList.replace(['opacity-100', 'translate-y-0'], ['opacity-0', 'translate-y-5'])
            this.$refs.wrapper.classList.replace(
              ['opacity-100', 'translate-y-0', 'pointer-events-all'],
              ['opacity-0', 'translate-y-5', 'pointer-events-none']
            )
          }, 2000)
        }
      }
    }
  }
</script>
